<template>
    <div>
        <form-container :header="translate('remInboxList.newRem')" v-on:save="saveDraft" :disabled="loading" v-if="data">
            <div class="row">
                <div class="col">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{translate('remInboxList.senderREMAccount')}}</label>
                        <div class="col-sm-10">
                            <select class="form-control" required v-model="data.ProviderId" name="providers" id="providers">
                                <option v-for="p in providers" :key="p.Id" :value="p.Id">{{p.Name}} ({{p.RemAddress}})</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{translate('targetSystem.rem.subject')}}</label>
                        <div class="col-sm-10">
                            <input v-model="data.Subject"  @input="checkInput('Subject',$event)" type="text" class="form-control" required />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{translate('targetSystem.rem.detsisNo')}} / {{translate('targetSystem.rem.barcodeNo')}}</label>
                        <div class="col-sm-10">
                            <input v-model="data.IletiDetay"  @input="checkInput('IletiDetay',$event)" type="number" class="form-control" />
                            <div class="text-right" v-show="!findDetsisBySearch">
                                <button @click="findDetsisBySearch = true" type="button" class="btn btn-link" :title="translate('targetSystem.rem.findDetsisBySearchTitle')">{{translate('targetSystem.rem.findDetsisBySearch')}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" v-if="findDetsisBySearch">
                        <label class="col-sm-2 col-form-label">{{translate('targetSystem.rem.organizationName')}}</label>
                        <div class="col-sm-10">
                            <select-input
                                :value="selectedValue"
                                :autocomplete="true"
                                :placeholder="translate('search')"
                                :datasource="detsisUrl"
                                @change="setDetsisNumber"
                                >
                                    <span>{{selectedValue}}</span>
                                    <template v-slot:item="{item}">
                                        {{prepareDetsisDisplayName(item)}}
                                    </template>
                            </select-input>
                            <div class="form-help">{{translate('targetSystem.rem.organizationSearchDetsisText')}}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{translate('remInboxList.receiverREMAdress')}}</label>
                        <div class="col-sm-10">
                            <vue-tags-input
                                v-model="to"
                                :tags="data.To || []"
                                placeholder="KEP adresi"
                                @tags-changed="newTags => data.To = newTags.map(x => x.text.toLowerCase())"
                                :save-on-key="[13]"
                                :seperators="[':', ';', ' ']"
                                :addOnKey="[9, 13, 32, 44, 58, 59]"
                                :allow-edit-tags="true"
                                @before-adding-tag="checkEmail"
                            />
                            <div class="text-right" v-show="!findRemBySearch">
                                <button @click="findByUnitName" type="button" class="btn btn-link" :title="translate('targetSystem.rem.findByUnitNameTitle')">{{translate('targetSystem.rem.findByUnitName')}}</button>
                            </div>
                        </div>
                        
                    </div>
                    
                    <div class="form-group row" v-if="findRemBySearch">
                        <label class="col-sm-2 col-form-label">{{translate('targetSystem.rem.organizationName')}}</label>
                        <div class="col-sm-10">
                            <select-input
                                :value="selectedValue"
                                :autocomplete="true"
                                :placeholder="translate('search')"
                                :datasource="detsisUrl"
                                @change="setValue"
                                >
                                    <span>{{selectedValue}}</span>
                                    <template v-slot:item="{item}">
                                        {{prepareDetsisDisplayName(item)}}
                                    </template>
                            </select-input>
                            <div class="form-help">{{translate('targetSystem.rem.organizationSearchText')}}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label">{{translate('draftEyp.attachments')}}</label>
                        <div class="col-sm-10">
                            <div class="form-control" style="height:auto; padding:0;">
                                <div v-if="!data.Attachments || !data.Attachments.length" class="text-muted" style="padding:4px 12px; font-style:italic; font-size:0.8rem;">{{translate('incomingDocument.noAttachedFile')}}</div>
                                <table v-else class="table table-borderless table-hover table-sm" style="margin-bottom:0;">
                                    <tbody>
                                        <tr v-for="d in data.Attachments" :key="d.id">
                                            <td class="remove align-top" @click="removeAttachment(d)" title="Kaldır"></td>
                                            <td>
                                                <!-- <a
                                                title="İndir"
                                                href="#void"
                                                @click.prevent="downloadAttachment(d)"
                                                >{{ d.FileName }}</a
                                                > -->
                                                <file-download-link  :isOnlineView="onlineViewEnabled" :document="d" @download="downloadAttachment" @preview="showFilePreview" ></file-download-link>
                                            </td>
                                            <td class="text-muted text-right" style="white-space:pre">{{d.Size | prettyBytes}}</td>
                                            <td style="vertical-align:top; width:1px;">
                                                <button class="btn btn-sm btn-light" style="padding: 0px 2px;" :title="translate('job.removeFile')" @click="removeAttachment(d)" v-if="d.CanRemove">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                        <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            <div class="float-right">
                                <file-upload
                                    ref="uploadAttachments"
                                    input-id="attachmentUpload"
                                    v-model="attachments"
                                    :post-action="
                                        axios.defaults.baseURL +
                                        '/remdraftattachment/post/' +
                                        data.Id
                                    "
                                    :multiple="true"
                                    :drop="false"
                                    :thread="1"
                                    @input="$refs.uploadAttachments.active = true"
                                    chunk-enabled
                                    :chunk="{
                                    headers: {
                                        token: axios.defaults.headers.common['token'],
                                    },
                                    action:
                                        axios.defaults.baseURL +
                                        '/remdraftattachment/post/' +
                                        data.Id,
                                    minSize: 0,
                                    maxActive: 3,
                                    maxRetries: 3,

                                    // Example in the case your backend also needs the user id to operate
                                    startBody: {
                                        //user_id: user.id
                                    },
                                    }"
                                >
                                    <!-- <div class="row select-file" id="attachments">
                                        <div class="col">
                                            İşe dahil edilecek ek dosyaları seçmek için buraya tıklayınız...
                                        </div>
                                    </div> -->
                                    <button type="button" class="btn btn-sm btn-outline-secondary" style="margin:12px 0;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                        </svg>
                                        {{translate('draft.addFile')}}
                                    </button>
                                </file-upload>
                            </div>
                            <div style="clear:both"></div>
                            <ul>
                                <!-- <li>{{file.name}} {{file.active}} {{file.success}} {{file.progress}} {{file.error}}</li> -->
                                <li
                                v-for="file in attachments"
                                :key="file.id"
                                v-show="!file.success"
                                >
                                <div>{{ file.name }}</div>
                                <div class="progress" v-if="file.active">
                                    <div
                                    class="progress-bar progress-bar-striped progress-bar-animated text-left"
                                    role="progressbar"
                                    aria-valuenow="75"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    :style="{ width: file.progress + '%' }"
                                    >
                                    &nbsp;%{{ parseInt(file.progress, 10) }}
                                    </div>
                                </div>
                                <div class="text-danger" style="font-size:0.8rem" v-if="file.error">
                                    <div v-for="ms in file.response.ModelState" :key="ms">
                                        <div v-for="err in ms" :key="err">{{err}}</div>
                                    </div>
                                </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div style="background-color:#FFF;">
                        <vue-editor v-model="data.Body" />
                    </div>
                </div>
            </div>
            <template v-slot:footer>
                <div class="row">
                    <div class="col"> 
                        <div class="row">
                            <div class="col">
                                
                            </div>
                            <div class="col popover-container">
                                <button type="submit" accesskey="k" class="btn btn-success" style="margin-right:8px;">{{translate('save')}}</button>
                                <div style="max-width: 100px;">
                                    <VDropdown placement='top' theme="dropdown">            
                                        <!-- This will be the popover target (for the events and position) -->
                                        <button type="button" accesskey="g" class="btn btn-primary">{{translate('send')}}</button>
                                        <!-- This will be the content of the popover -->
                                        <template #popper>
                                            <button class="btn btn-info btn-sm" style="margin: 10px" @click="signRem">{{translate('eSign')}}</button>
                                            <button class="btn btn-info btn-sm" style="margin: 10px" @click="sendWithMobileSignature">{{translate('mobileSignatureTexts.mobileSign')}}</button>
                                        </template>
                                    </VDropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </form-container>
        <div v-else>
            {{translate('loading')}}
        </div>
        
        <!-- MOBİL İMZA MODAL BAŞLANGICI -->
        <div v-if="isMobilePanelVisible" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{translate('job.signWithMobileSing')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" :disabled="imzalayiciLoading" :aria-label="translate('close')" @click="closeMobileSignModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <mobil-imzala ref="mobileSign" :items="mobileItems"  @completed="signingCompleted" :processingMessage="processingMessage"></mobil-imzala>
                </div>
                <div class="modal-footer footer-button-container-1">
                    <button type="button" class="btn btn-outline-secondary" @click="closeMobileSignModal()">{{translate('close')}}</button>
                    <!-- <button type="button" class="btn btn-danger" style="width:100px;" v-show="imzalayiciLoading" @click="$refs.mobileSign.cancel()" data-dismiss="modal">İptal</button> -->

                    <button type="submit" class="btn btn-success" style="width:140px;" :disabled="imzalayiciLoading" @click="$refs.mobileSign.sign()">{{translate('mobileSignatureTexts.mobileSign')}}</button>

                </div>
                </div>
            </div>
        </div>
        <!-- MOBİL İMZA MODAL SONU -->
                    <signature-modal
                        v-if="isSignaturePanelVisible"
                        :signingItems="signingItems"
                        :identityNumber="identityNumber"
                        :processingMessage="processingMessage"
                        @close="isSignaturePanelVisible=false"
                        @completed="signingCompleted"
                         ></signature-modal>
        <file-preview v-if="fileDetail" style="z-index: 999;" :file="fileDetail" :isOnlineView="onlineViewEnabled" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
    </div>
</template>
<script>
import axios from 'axios'
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import { VueEditor } from "vue2-editor";
import mobilImzala from '../components/MobileSign.vue'

import VueTagsInput from '@johmun/vue-tags-input';  // http://www.vue-tags-input.com/#/start
import fileUpload from "vue-upload-component"; // https://lian-yue.github.io/vue-upload-component/#/en/documents#getting-started-npm
import signatureModal from '../components/SignatureModal.vue'

import FileDownloadLink from '../components/FileDownloadLink.vue';
import FilePreview from '../components/FilePreview.vue';

import selectInput from '../components/SelectInput.vue';


import Vue from 'vue';
import 'floating-vue/dist/style.css'

import {
  // Directives
  VTooltip,
  VClosePopper,
  // Components
  Dropdown,
  Tooltip,
  Menu
} from 'floating-vue'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popper', VClosePopper)

Vue.component('VDropdown', Dropdown)
Vue.component('VTooltip', Tooltip)
Vue.component('VMenu', Menu)


export default {
    mixins: [formMixin],
    components: {
        formContainer,
        VueEditor,
        VueTagsInput,
        fileUpload,
        signatureModal,
        mobilImzala,
        FileDownloadLink,
        FilePreview,
        selectInput
    },
    
    created(){
        this.getRemProviders()
        .then(x => {
            this.providers = x.Result;
        })
        this.getOnlineViewPermission()
        .then(x => {
            this.onlineViewEnabled = x;
        }).catch(x => {
            console.warn("getOnlineViewPermission alınamadı:", x);
            this.onlineViewEnabled = true;
        });
        this.getData(this.$route.params.id, true, this.$route.query.kind);
    },
    data() {
        return {
            loading: false,
            modelName: 'RemMessageDraft',
            data: null,
            providers: null,
            redirectToList: false,
            to: '',
            attachments: [],
            isSignaturePanelVisible: false,
            signingItems: null,
            identityNumber: null,
            isMobilePanelVisible: false,
            onlineViewEnabled: true,
            fileDetail: null,           // Önizlemesi görüntülenecek dosya
            findRemBySearch :false,
            findDetsisBySearch: false,
            selectedValue:'',
        }
    },
    watch: {
        attachments: function (oldFiles, newFiles) {
            console.log('Newfiles: ', newFiles);
            newFiles
                .filter((x) => x && x.response.attachment)
                .forEach((element) => {
                if (
                    this.data.Attachments.filter(
                    (d) => d.Id == element.response.attachment.Id
                    ).length == 0
                ) {
                    this.data.Attachments.push(element.response.attachment);
                    console.log("Attachments", this.data.Attachments);
                }

                this.$refs.uploadAttachments.remove(element);
                });
        },
    },
    computed: {
        provider(){
            return this.providers.filter(x => x.Id == this.data.ProviderId)[0];
        },
        detsisUrl(){
            return window.settings.detsisApiUrl + "Detsis/filterByName";
        },
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        saveDraft(){
            this.save().then((x) => {
                console.log("Save result: ", x);
                if (x && x.status == 200 && x.data) {
                    this.data = x.data;
                    this.$router.replace({ params: { id:this.data.Id } });
                    alert(this.translate('messages.draftSaveSuccess'));
                }
            });
        },
        checkEmail(obj){
            if(window.settings.isTestMode) {
                obj.addTag();
                return;
            }

            var exp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (!obj.tag.text.match(exp))
                return;
            else if(!obj.tag.text.match(/\.kep\.tr$/)) {
                alert(this.translate('errors.invalidExtensionForKepTarget'));
                return;
            }
            else
                obj.addTag();
        },
        removeAttachment(attachment) {
            this.data.Attachments = this.data.Attachments.filter(
                (x) => x != attachment
            );
        },
        downloadAttachment(attachment) {
            // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
                .post(`/remMessageDraft/createAttachmentUrl/`, {
                    EntityId: this.data.Id,
                    AttachmentId: attachment.Id,
                    })
                    .then((x) => {
                    console.log("createAttachmentUrl Result:", x.data);
                    window.open(x.data.Data.Url);
                    })
                .catch((x) => window.processErrorResponse(x, this));
        },
        showFilePreview(document, type) {
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            this.fileDetail.EntityType = "RemMessageDraft"
        },
        validate(){
            this.loading = true;
            this.errorMessage = null;
            return axios
              .post(`/RemMessageDraft/validate/${this.data.Id}`, this.data)
              .then(x => {
                return x;
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
              });
        },
        // send(){
        //     if(!this.data.ProviderId) {
        //         alert('Gönderici KEP hesabını seçiniz.');
        //         return
        //     }

        //     this.validate().then((x) => {
        //         console.log('Validate then: ', x);
        //         if(x && x.status === 200)
        //             this.signRem();
        //     })  
        // },
        signRem(){
            if(!this.data.ProviderId) {
                alert(this.translate('warnings.chooseSenderKEPAddress'));
                return
            }

            this.save().then((x) => {
                console.log("Save result: ", x);
                if (x && x.status == 200 && x.data) {
                    this.data = x.data;
                    this.$router.replace({ params: { id:this.data.Id } });
                    this.validate().then((x) => {
                        console.log('Validate then: ', x);
                        if(x && x.status === 200)
                            if(!this.$root.$data.login.User.IdentityNumber) {
                                if(confirm(this.translate('warnings.identityMissing'))) {
                                    this.$router.push({ name:'UserIdentity', params: { id: this.$root.$data.login.User.Id } });
                                }
                                return;
                            }

                            this.signingItems = [];
                            if(this.provider.ESignLogin)
                            {
                                this.signingItems.push({
                                    DocumentId: "agreement",
                                    SignatureFormat: "CAdES",
                                    FileName : "KEP oturum taahhütnamesi.txt",
                                    State: '',
                                    GetUrl: `/RemBox/login?providerId=${this.data.ProviderId}`,
                                    PostUrl: '/RemBox/login',
                                    PostParams: { ProviderId: this.data.ProviderId, JobId: "keplogin", DocumentId: "agreement" }
                                });
                            }
                            
                            this.signingItems.push({
                                    DocumentId: "mime",
                                    SignatureFormat: "CAdES",
                                    FileName : "KEP iletisi.eml",
                                    State: '',
                                    GetUrl: `/RemMessageDraft/ContentForSign?id=${this.data.Id}`,
                                    PostUrl: '/RemMessageDraft/ContentForSign',
                                    PostParams: { MessageId: this.data.Id, DocumentId: 'mime', JobId: "kepsign" }
                            });

                            this.isSignaturePanelVisible = true;
                            this.loading = false;
                    })  
                }
            });

            
        },
        sendWithMobileSignature(){
            // Mobil İmza ile KEP gönderimi için imza panelini açar

            if(!this.data.ProviderId) {
                alert(this.translate('warnings.chooseSenderKEPAddress'));
                return
            }
            this.save().then((x) => {
                console.log("Save result: ", x);
                if (x && x.status == 200 && x.data) {
                    this.data = x.data;
                    this.$router.replace({ params: { id:this.data.Id } });
                    this.validate().then((x) => {
                        console.log('Validate then: ', x);
                        if(x && x.status === 200)
                            if(!this.$root.$data.login.User.IdentityNumber) {
                                if(confirm(this.translate('warnings.identityMissing'))) {
                                    this.$router.push({ name:'UserIdentity', params: { id: this.$root.$data.login.User.Id } });
                                }
                                return;
                            }

                            this.mobileItems = [];

                            if(this.provider.ESignLogin) {
                                this.mobileItems.push({
                                    DocumentId: "agreement",
                                    SignatureFormat: "CAdES",
                                    FileName : "KEP oturum taahhütnamesi.txt",
                                    State: '',
                                    FingerprintUrl: `/RemBox/CalculateFingerprintForLogin/?providerId=${this.data.ProviderId}`,
                                    PostUrl: `/RemBox/SignMobileForLogin/?providerId=${this.data.ProviderId}&fingerPrintTempFileId={0}`,
                                    PostParams: { ProviderId: this.data.ProviderId }
                                });
                            }
                            
                            this.mobileItems.push({
                                    DocumentId: "mime",
                                    SignatureFormat: "CAdES",
                                    FileName : "KEP iletisi.eml",
                                    State: '',
                                    FingerprintUrl: `/RemMessageDraft/CalculateFingerprint/?id=${this.data.Id}`,
                                    PostUrl: `/RemMessageDraft/SignMobile/?id=${this.data.Id}&fingerPrintTempFileId={0}`,
                                    PostParams: { id: this.data.Id}
                                });
                                
                        this.isMobilePanelVisible = true;   
                    })  
                }
            });
            

                    
        },
        signingCompleted(){
            this.loading = true;
            this.processingMessage = this.translate('processingMessages.remSending');
            axios.post('RemMessageDraft/send/' + this.data.Id)
            .then(() => {
                this.processingMessage = this.translate('messages.sendSuccess');
                this.$router.push({ name:'RemOutbox', params: { provider: this.data.ProviderId } });
            })
            .catch(x => {
                this.processingMessage = null;
                window.processErrorResponse(x, this);
                this.isSignaturePanelVisible = false;
            })
        },
        closeMobileSignModal(){
            this.isMobilePanelVisible = false;
            this.loading = false;
        },
        async setDetsisNumber(val){
            this.selectedValue = val.Ad;
            this.data.IletiDetay = val?.DETSISNo;
            this.findDetsisBySearch = false;
        },
        async  setValue(val){
            this.selectedValue = val.Ad;
            this.data.IletiDetay = val?.DETSISNo;
            var tempVal;
            const remAddress = await  this.getDetsisUnitRem(val.DETSISNo).then(x=> { 
                if(x.data.Data == null){
                    alert(this.translate('errors.organizationNotPresentInKaysis'));
                    console.log(tempVal);
                    tempVal = '';
                } else if(!x.data.Data.Aktifmi) {
                    alert(this.translate('errors.activeKepAccountNotFoundForOrganization'));
                    tempVal = '';
                } else { 
                    tempVal = x.data.Data.KepAdresi; 
                }
                return tempVal;
            }); 
            if(remAddress) {
                console.log('remAddress: ', remAddress);
                
                if(typeof this.data.To === 'string')
                    this.data.To = [this.data.To];

                this.data.To = this.data.To.filter(x => x != remAddress);

                this.data.To.push(remAddress);
                this.findRemBySearch = false;
                this.selectedValue = '';
                this.$forceUpdate();
            }
        },
        findByUnitName(){
            this.findRemBySearch = true;
        },
        prepareDetsisDisplayName(item){
            var ustKurum = item.KurumHiyerarsik;
            var replaced = ustKurum.replace(item.Ad,'').trim();
            if(replaced.endsWith('>'))
                replaced = replaced.replace(new RegExp('>' + '$'), '').trim();
            if(replaced)
                replaced = ' ('+replaced+')';
            return item.Ad+ replaced;
        },
    }
}
</script>

<style scoped>
.popover-container{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
}

.footer-button-container-1{
    display: flex;
    align-items: center;
    justify-content: space-between !important;
}
</style>